/** Ship-to is ID only (no customer name in upstream events). */
export function buildShipToFields(shipToId) {
  const shipToCode = (shipToId || "").trim() || "—";
  return {
    shipToCode,
    shipTo: shipToCode,
  };
}

/** Map spur_details API ship_to (id or Mixed (n)) to grid row fields. */
export function buildSpurSummaryShipToFields(shipToFromApi) {
  const raw = (shipToFromApi || "").trim();
  if (!raw) {
    return { shipTo: "—", shipToCode: "—" };
  }
  if (raw.startsWith("Mixed (")) {
    return { shipTo: raw, shipToCode: "—" };
  }
  return buildShipToFields(raw);
}
